import { Switch, Route, Redirect } from "react-router-dom";
import UnauthorizedAccess from "../components/UnauthorizedAccess/UnauthorizedAccess";

export const UnAuthRoute = (
  <Switch>
    {/* <Redirect from="/?Code*" to="/" /> */}
    <Route exact path="/" render={()=> <UnauthorizedAccess />} />
  </Switch>
);
